export default function initHeadingsDecor() {
  const headingsDecorHolders = document.querySelectorAll('.headings-decor');
  if (headingsDecorHolders.length === 0) return;

  const activeClass = 'active';
  const animatedItems = new Set();

  const observer = new IntersectionObserver((entries) => {
    // Filter only intersecting and not yet animated items
    const newEntries = entries.filter((entry) => entry.isIntersecting && !animatedItems.has(entry.target));

    newEntries.forEach((entry, index) => {
      const delay = index * 300; // 300ms stagger delay
      setTimeout(() => {
        entry.target.classList.add(activeClass);
        animatedItems.add(entry.target);
      }, delay);
    });
  });

  headingsDecorHolders.forEach((headingsDecorHolder) => {
    const lines = headingsDecorHolder.querySelectorAll('.lines-container .line');
    lines.forEach((line) => observer.observe(line));
  });
}
